module.exports = __webpack_public_path__ + "9785d3dc76c733c230cd3a18f94542d3.MP3";